<template>
  <div class="order-step">
    <div class="two-col-res">
      <div>
        <div class="card">
          <div class="card-selection">
            <div class="list-container list-left list-header">
              <address-list
                :currentAddress="address"
                type="deliver"
                @setAddress="setAddress"
              ></address-list>
            </div>

            <div class="selection-main">
              <div class="details-container">
                <div class="title-container">
                  <h3>Opdrachtomschrijving</h3>
                </div>
                <p
                  class="error-text details-text-error pointer"
                  v-if="orderDetails.instruction.length == 0 && !focus"
                  @click="setFocus"
                >
                  Omschrijf hier uw opdracht.
                </p>
                <textarea
                  id="copy-instruction"
                  class="details-text required grey-field"
                  :value="orderDetails.instruction"
                  @input="updateOrder('instruction', $event.target.value)"
                  ref="description"
                  @blur="focus = false"
                ></textarea>
              </div>

              <div class="title-container">
                <h3>Ophaaladres</h3>
                <button
                  class="white-pill-s"
                  @click="editAddress('editPickup')"
                  v-if="!custom.addresses.editDelivery"
                >
                  Bewerken
                </button>

                <button
                  class="white-pill-s"
                  v-if="!custom.addresses.newDelivery"
                  @click="editAddress('newPickup')"
                >
                  Nieuw
                </button>
              </div>
              <div>
                <div class="address">
                  <p
                    class="error-text pointer"
                    v-if="!address.company"
                    @click="editAddress('newPickup')"
                  >
                    Uw Ophaaladres is nog niet compleet, klik hier.
                  </p>
                  <p v-else>{{ address.company }}</p>
                  <p
                    v-if="!address.department && custom.department.required"
                    class="error-text pointer"
                    @click="editAddress('editPickup')"
                  >
                    <span>Vul een </span>
                    <span
                      >{{
                        custom.department.label
                          ? custom.department.label
                          : 'Afdeling'
                      }}
                    </span>
                    <span>in, klik hier.</span>
                  </p>
                  <p v-else-if="address.department">
                    <span
                      >{{
                        custom.department.label
                          ? custom.department.label
                          : 'Afd. '
                      }}
                    </span>
                    <span>{{ address.department }}</span>
                  </p>
                  <p v-if="address.name">T.a.v. {{ address.name }}</p>
                  <p>
                    {{ address.street }} {{ address.number }}
                    {{ address.addition }}
                  </p>
                  <p>{{ address.zipCode }} {{ address.city }}</p>
                  <p class="del-select">
                    <select-box
                      @action="setDeliver"
                      :selected="
                        address.id == orderDetails.deliveryAddress.id &&
                        deliverIsPickup
                      "
                    ></select-box
                    ><span @click="setDeliver">Dit is ook het bezorgadres</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="card card-front sub-card">
          <div class="card-default">
            <div class="top">
              <day-picker
                :dates="dates"
                :active-date="orderDetails.pickUpDate"
                @setDate="setDate"
                class="day-picker"
                :type="'pickup'"
              ></day-picker>
            </div>
            <address-card :address="shop"></address-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DayPicker from '@/components/ui/DayPicker'
import AddressCard from '@/components/AddressCard'
import AddressSelectionList from '@/components/AddressSelectionList'
import { mapStores } from 'pinia'

import EditDeliveryAddress from '@/dialogs/EditDeliveryAddress'
import { add } from 'date-fns'

export default {
  props: ['shop', 'dates', 'orderDetails'],
  data() {
    return {
      addresses: [],
      focus: false,
      deliverIsPickup: true
    }
  },
  components: {
    DayPicker,
    AddressList: AddressSelectionList,
    AddressCard
  },
  methods: {
    editAddress(type) {
      this.$modal.show(
        EditDeliveryAddress,
        {
          type: type,
          address: { ...this.orderDetails.pickUpAddress },
          callback: (model) => {
            this.setAddress(model)
          }
        },
        { width: 420, height: 'auto' }
      )
    },
    updateOrder(key, val) {
      this.$emit('updateOrder', [key, val])
    },
    setAddress(address) {
      this.updateOrder('pickUpAddress', address)

      if (this.deliverIsPickup) {
        this.updateOrder('deliveryAddress', address)
      }
    },
    setDate(date) {
      date.time = date.times[0].time
      this.updateOrder('pickUpDate', date)
    },
    setDeliver() {
      this.deliverIsPickup = !this.deliverIsPickup
      if (this.deliverIsPickup) {
        this.updateOrder('deliveryAddress', this.orderDetails.pickUpAddress)
      }
    },
    setFocus() {
      this.focus = true
      this.$refs.description.focus()
    }
  },
  computed: {
    custom() {
      return this.rootStore.theme.customFields
    },
    address() {
      return this.orderDetails.pickUpAddress
    }
  }
}
</script>

<style lang="scss" scoped>
.list-header {
  padding-top: 15px;
}
.address {
  line-height: 1.5rem;
  min-height: 175px;
}

.details-container {
  height: 175px;

  .error-text {
    position: absolute;
    padding: 10px;
  }

  textarea {
    width: 100%;
    height: 140px;
  }
}

.del-select {
  margin-top: 14px;
}

.top {
  flex-grow: 1;
}
</style>
